import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import { useTenantId } from './useTenant';

/**
 * GET /api/tenants/<id>/client-reliability — dispatcher-facing (this
 * console, not the client portal): for every active client site, what
 * fraction of its recent deliveries were independently GPS-confirmed at
 * arrival versus merely asserted by a manual status tap. See
 * blueprints/reporting.py's client_reliability() docstring for the window,
 * the low-sample rule, and why a zero-delivery or low-sample site still
 * appears in `rows` rather than being dropped.
 *
 * Returns { rows, window_days, low_sample_threshold }. Each row carries
 * gps_confirmed_rate (0.0-1.0, or null when delivered_count is 0) and
 * low_sample (true when delivered_count is below low_sample_threshold) —
 * the frontend must not treat a low_sample row's rate as a confident
 * finding.
 */
export function useClientReliability() {
  const tenantId = useTenantId();
  return useQuery({
    queryKey: ['client-reliability', tenantId],
    queryFn: () => api(`/api/tenants/${tenantId}/client-reliability`),
    enabled: Boolean(tenantId),
    staleTime: 60_000,
  });
}
